import {
	ContextService,
	FootballService,
	ImportService,
	PlayerService,
	TennisService
} from "@prestosports/prestostats-core/Services";
import { Player } from "@prestosports/prestostats-core/Common";
import {
	CANCEL_IMPORT_PLAYERS_COMPLETE,
	DELETE_IMPORT_PLAYERS,
	DELETE_PLAYER_COMPLETE,
	DELETE_PLAYERS_COMPLETE,
	GENERATE_HEADERS,
	IMPORT_PLAYERS,
	IMPORT_PLAYERS_COMPLETE,
	INIT_PLAYERS,
	INIT_PLAYERS_COMPLETE,
	PARSE_CSV,
	SAVE_IMPORT_PLAYERS,
	SAVE_IMPORT_PLAYERS_COMPLETE,
	SAVE_PLAYER,
	SAVE_PLAYER_COMPLETE,
	SET_VIEW
} from "./constants";
import Alert from "../../util/alert";
import { GENERIC_ERROR_MSG } from "../../contstants/errors";
import {
	GENERIC_DELETED_MSG,
	GENERIC_SAVED_MSG
} from "../../contstants/successes";
import { saveTeamContext } from "../team-context/actions";

export const initFootballPlayers = async (teams, dispatch) => {
	dispatch({
		type: INIT_PLAYERS
	});

	const { homeTeam, awayTeam } = teams;
	const homePlayers = await FootballService.getPlayers(homeTeam.teamId);
	const awayPlayers = await FootballService.getPlayers(awayTeam.teamId);
	const players = [...homePlayers, ...awayPlayers];

	dispatch({
		type: INIT_PLAYERS_COMPLETE,
		payload: {
			players: players.map((p) => p.toJSON())
		}
	});
};

export const initTennisPlayers = async (teams, dispatch) => {
	dispatch({
		type: INIT_PLAYERS
	});

	const { homeTeam, awayTeam } = teams;
	const homePlayers = await TennisService.getPlayers(homeTeam.teamId);
	const awayPlayers = await TennisService.getPlayers(awayTeam.teamId);
	const players = [...homePlayers, ...awayPlayers];

	dispatch({
		type: INIT_PLAYERS_COMPLETE,
		payload: {
			players: players.map((p) => p.toJSON())
		}
	});
};

export const savePlayer = async (player, game, dispatch) => {
	const newPlayer = Object.assign(new Player(), player);
	dispatch({
		type: SAVE_PLAYER,
		payload: { id: player.id }
	});
	try {
		const savedPlayer = await PlayerService.savePlayer(newPlayer);
		if (!newPlayer.id) {
			const { teamId } = player;
			const gameContext = await ContextService.toggleDefaults(game.id, teamId, [
				savedPlayer.id
			]);
			await saveTeamContext(game, gameContext.getTeamContext(teamId), dispatch);
		}
		Alert.success(GENERIC_SAVED_MSG);
		dispatch({
			type: SAVE_PLAYER_COMPLETE,
			payload: { player: savedPlayer.toJSON() }
		});
	} catch (e) {
		Alert.error(GENERIC_ERROR_MSG);
		throw Error(e);
	}
};

export const deletePlayer = async (player, dispatch) => {
	try {
		await PlayerService.deletePlayer(player.id);
		Alert.success(GENERIC_DELETED_MSG);
		dispatch({
			type: DELETE_PLAYER_COMPLETE,
			payload: { player }
		});
	} catch (e) {
		Alert.error(GENERIC_ERROR_MSG);
		throw Error(e);
	}
};

export const deletePlayers = async (playerIds, dispatch) => {
	try {
		await PlayerService.deletePlayers(playerIds);
		Alert.success(GENERIC_DELETED_MSG);
		dispatch({
			type: DELETE_PLAYERS_COMPLETE,
			payload: { playerIds }
		});
	} catch (e) {
		Alert.error(GENERIC_ERROR_MSG);
		throw Error(e);
	}
};

export const importPlayers = async (importResult, teamId, dispatch) => {
	dispatch({ type: IMPORT_PLAYERS });

	const { importedPlayers, importErrors } = await ImportService.importPlayers(
		teamId,
		importResult
	);

	dispatch({
		type: IMPORT_PLAYERS_COMPLETE,
		payload: {
			importErrors: {
				[teamId]: importErrors
			},
			importedPlayers: {
				[teamId]: importedPlayers
			}
		}
	});
};

export const saveImportPlayers = async (
	teamId,
	players,
	existingPlayers,
	game,
	dispatch
) => {
	try {
		dispatch({
			type: SAVE_IMPORT_PLAYERS
		});
		const savedPlayers = await ImportService.savePlayers(teamId, players);
		const newPlayerIds = savedPlayers
			.filter((sp) => !existingPlayers.some((ep) => ep.id === sp.id))
			.map((p) => p.id);

		if (newPlayerIds.length) {
			const gameContext = await ContextService.toggleDefaults(
				game.id,
				teamId,
				newPlayerIds
			);
			await saveTeamContext(game, gameContext.getTeamContext(teamId), dispatch);
		}

		const gameContext = await ImportService.setGameData(game.id, teamId, players);
		await saveTeamContext(game, gameContext.getTeamContext(teamId), dispatch);

		Alert.success(GENERIC_SAVED_MSG);
		dispatch({
			type: SAVE_IMPORT_PLAYERS_COMPLETE,
			payload: { players: savedPlayers }
		});
	} catch (e) {
		Alert.error(GENERIC_ERROR_MSG);
		throw Error(e);
	}
};

export const cancelImportPlayers = (dispatch) => {
	dispatch({
		type: CANCEL_IMPORT_PLAYERS_COMPLETE,
		payload: { players: [] }
	});
};

export const parseCsv = (dispatch) => {
	dispatch({
		type: PARSE_CSV
	});
};

export const getCsvHeaders = async (teamId, dispatch) => {
	const csvHeaders = await ImportService.generateHeaders(teamId);

	dispatch({
		type: GENERATE_HEADERS,
		payload: { csvHeaders }
	});
};

export const setView = (value, dispatch) => {
	dispatch({ type: SET_VIEW, payload: { view: value } });
};

export const deleteImportPlayers = async (
	teamId,
	currentPlayers = [],
	playersToDelete = [],
	dispatch
) => {
	const players = currentPlayers.filter(
		(ip) => !playersToDelete.find((p) => ip.importIndex === p.importIndex)
	);

	await ImportService.validatePlayers(teamId, players);

	dispatch({
		type: DELETE_IMPORT_PLAYERS,
		payload: {
			importedPlayers: {
				[teamId]: players
			}
		}
	});
};
